import React from "react";

const MoneySvg = () => {
  return (
    <svg
      width="19"
      height="19"
      viewBox="0 0 19 19"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12.7678 2.62866H5.25739C3.00427 2.62866 1.5022 3.75522 1.5022 6.38385V11.6411C1.5022 14.2697 3.00427 15.3963 5.25739 15.3963H12.7678C15.0209 15.3963 16.5229 14.2697 16.5229 11.6411V6.38385C16.5229 3.75522 15.0209 2.62866 12.7678 2.62866ZM4.69411 10.8901C4.69411 11.198 4.43875 11.4534 4.13083 11.4534C3.8229 11.4534 3.56755 11.198 3.56755 10.8901V7.13489C3.56755 6.82696 3.8229 6.57161 4.13083 6.57161C4.43875 6.57161 4.69411 6.82696 4.69411 7.13489V10.8901ZM9.01257 11.2656C7.76585 11.2656 6.75946 10.2592 6.75946 9.01248C6.75946 7.76576 7.76585 6.75937 9.01257 6.75937C10.2593 6.75937 11.2657 7.76576 11.2657 9.01248C11.2657 10.2592 10.2593 11.2656 9.01257 11.2656ZM14.4576 10.8901C14.4576 11.198 14.2022 11.4534 13.8943 11.4534C13.5864 11.4534 13.331 11.198 13.331 10.8901V7.13489C13.331 6.82696 13.5864 6.57161 13.8943 6.57161C14.2022 6.57161 14.4576 6.82696 14.4576 7.13489V10.8901Z"
        fill="#7EC2FF"
      />
    </svg>
  );
};

export default MoneySvg;
